import { Box } from 'braid-design-system';

import * as pageBlockStyles from './PageBlock.css';

export const PageBlock: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Box
    className={pageBlockStyles.pageBlock}
    display="flex"
    flexDirection="column"
    paddingY="none"
    paddingX={['none', 'xsmall']}
    marginY="none"
  >
    {children}
  </Box>
);
